import { render, staticRenderFns } from "./jobSlip.vue?vue&type=template&id=1275b736&scoped=true"
import script from "./jobSlip.vue?vue&type=script&lang=js"
export * from "./jobSlip.vue?vue&type=script&lang=js"
import style0 from "./jobSlip.vue?vue&type=style&index=0&id=1275b736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275b736",
  null
  
)

export default component.exports